import React from 'react';

import { useIntl } from 'react-intl';

import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	IconButton,
	type IconButtonAppearance,
	type IconButtonSpacing,
} from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/core/copy';
import { token } from '@atlaskit/tokens';

import messages from './messages';

type CopyResponseProps = {
	onClick: (event: UIAnalyticsEvent) => void;
	appearance?: IconButtonAppearance;
	spacing?: IconButtonSpacing;
	shape?: 'default' | 'circle';
};

export const CopyResponse = (props: CopyResponseProps): React.JSX.Element => {
	const { onClick, appearance = 'subtle', spacing = 'compact', shape = 'default' } = props;

	const { formatMessage } = useIntl();
	const copyResponseLabel = formatMessage(messages.copyResponseLabel);

	return (
		<IconButton
			isTooltipDisabled={false}
			type="button"
			onClick={(_, event: UIAnalyticsEvent) => onClick(event)}
			icon={(iconProps) => <CopyIcon {...iconProps} color={token('color.icon.subtle')} />}
			appearance={appearance}
			spacing={spacing}
			label={copyResponseLabel}
			shape={shape}
		/>
	);
};
